<template>
    <!-- Modal -->
    <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="componentModal"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">New component</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <component-create></component-create>
            </div>
        </div>
    </div>
</template>
<script>
    import ComponentCreate from "@/views/component/Form.vue"

    export default {
        components: {
            ComponentCreate
        }
    }
</script>
